import { filterOptions } from '@/utils/query-base'
import { formatSapDate } from '@/mixins/index'

const all = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'BT', 'GT', 'LT', 'LE', 'GE'])
const cusname = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'CP-S'])

export const pageSearch = {}

export default {
  'rev_int_id': {
    title: '积分申请单号',
    type: 'input',
    equation: all,
    width: 120
  },
  'customer': {
    title: '客户编号',
    width: 120
  },
  'custname': {
    title: '客户名称',
    width: 200
  },
  'quantity': {
    title: '积分数量',
    width: 120,
    xlsxFmt: {
      t: 'n'
    },
    formatter: ({ cellValue }) => {
      if (cellValue?.endsWith('-')) {
        return '-' + cellValue.replace('-', '')
      } else {
        return cellValue
      }
    }
  },
  'status_text': {
    title: '状态描述',
    type: 'input',
    equation: cusname,
    width: 150
  },
  'datum': {
    title: '申请日期',
    type: 'date',
    equation: all,
    formatter: ({ cellValue }) => formatSapDate(cellValue),
    width: 120
  },
  'uzeit': {
    title: '申请时间',
    width: 120
  },
  'uname': {
    title: '申请人',
    type: 'input',
    equation: all,
    width: 120
  }
}




// WEBPACK FOOTER //
// ./src/views/integral-manage/config/pointApplyQuery.js